import { ofType } from 'redux-observable';

import { tap, mapTo } from 'rxjs/operators';

import { FETCH_CLIENT_ERROR, LOG_OUT } from '../constants';

import { deleteCredentials } from '../../utilities/localStorage';
import { pushRoute } from '../../utilities/helpers';

const clientError = action$ =>
  action$.pipe(
    ofType(FETCH_CLIENT_ERROR),
    tap(() => {
      deleteCredentials();
      pushRoute('/login');
    }),
    mapTo({ type: LOG_OUT })
  );

export default clientError;
